import React from "react";
import PropTypes from "prop-types";
import {DateTimePicker} from 'react-widgets';
import moment from "moment-timezone";
import momentLocalizer from "react-widgets-moment";
import {Grid} from "semantic-ui-react/dist/commonjs/collections/Grid/Grid";

class BasicDateTimePicker extends React.Component {
    constructor(props) {
        super(props);

        moment.locale('en');
        momentLocalizer();
    }

    render() {
        return (
            <div className='ui input basic-datetime-picker-field'>
                <div className="basic-datetime-picker-field-label">
                    {this.props.label}
                </div>
                <DateTimePicker date={true}
                                time={this.props.time}
                                disabled={this.props.disabled}
                                value={this.props.value}
                                onChange={this.props.onValueChanged}
                />
            </div>
        )
    }
}

BasicDateTimePicker.propTypes = {
    label: PropTypes.node,
    onValueChanged: PropTypes.func,
    value: PropTypes.any,
    time: PropTypes.bool,
};

BasicDateTimePicker.defaultProps = {
    time: true
};

export default BasicDateTimePicker;


// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/DateTimePicker.jsx